class MediaPlayer {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.init()
    }
    init() {
        document.querySelectorAll('[data-media-player]').forEach(el => {
            new MediaPlayerItem(el, this)
        })
    }
}

class MediaPlayerItem {
    constructor(element, parent) {
        this.element = element
        this.parent = parent
        this.init()
    }
    init() {
        this.timeoutHandler = null
        this.element.querySelector('[data-media-player-play]').addEventListener('click', () => {
            const video = this.element.querySelector('video')
            video.play()
            video.setAttribute('controls', 'controls')
            this.element.classList.add('is-playing')
        })
        this.element.querySelector('video').addEventListener('play', (evt) => {
            if (this.timeoutHandler) {
                clearTimeout(this.timeoutHandler)
            }
            this.element.classList.add('is-playing')
            evt.target.setAttribute('controls', 'controls')
        })
        this.element.querySelector('video').addEventListener('pause', (evt) => {
            if (this.timeoutHandler) {
                clearTimeout(this.timeoutHandler)
            }
            this.timeoutHandler = setTimeout(() => {
                this.element.classList.remove('is-playing')
                if (evt.target.currentTime === evt.target.duration) {
                    this.element.classList.remove('is-pausing')
                } else {
                    this.element.classList.add('is-pausing')
                }
                evt.target.removeAttribute('controls')
            }, 1000)
        })
        this.element.querySelector('video').addEventListener('ended', (evt) => {
            if (this.timeoutHandler) {
                clearTimeout(this.timeoutHandler)
            }
            this.element.classList.remove('is-playing')
            this.element.classList.remove('is-pausing')
            evt.target.removeAttribute('controls')
        })
    }
}

export default MediaPlayer